/* global axios */
import ApiClient from './ApiClient';

class BranchesAPI extends ApiClient {
  constructor() {
    super('branches', { accountScoped: true });
  }

  geocode(address) {
    return axios.post(`${this.url}/geocode`, { address });
  }
}

class BranchBrandsAPI extends ApiClient {
  constructor() {
    super('branch_brands', { accountScoped: true });
  }
}

class BranchCitiesAPI extends ApiClient {
  constructor() {
    super('branch_cities', { accountScoped: true });
  }
}

export const branchesAPI = new BranchesAPI();
export const branchBrandsAPI = new BranchBrandsAPI();
export const branchCitiesAPI = new BranchCitiesAPI();
